export default "__VITE_ASSET__Ci6$YA_V__"